import type { Token } from './types';

const TOKEN_CLASS_MAP: Record<string, string> = {
  keyword: 'qk',
  function: 'qf',
  string: 'qs',
  number: 'qn',
  operator: 'qo',
  comparison: 'qc',
};

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Render an array of tokens to an HTML string with CSS class spans.
 * Used by the web client for syntax-highlighted query blocks.
 */
export function renderToHTML(tokens: Token[]): string {
  return tokens
    .map((token) => {
      const escaped = escapeHtml(token.value);
      const cls = TOKEN_CLASS_MAP[token.type];
      return cls ? `<span class="${cls}">${escaped}</span>` : escaped;
    })
    .join('');
}
